export default __webpack_public_path__ + "static/media/placeholder-user.4ff37bc1.jpg";